// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject11":"Amazon-module--seeLiveProject11--3-jQk","sourceCodeProject11":"Amazon-module--sourceCodeProject11--2zQBm"};